import React from "react";

import { useModalContext } from "./Modal";

export default function ModalBody({ children, styles }: { children: React.ReactNode; styles?: React.CSSProperties }) {
  useModalContext();

  const defaultStyle = {
    padding: "48px",
  };

  return (
    <section style={{ ...defaultStyle, ...styles }} className="modal-card-body">
      {children}
    </section>
  );
}
